import { useNavigate } from 'react-router'
import { Alert, Typography } from '@mui/material'

import FullScreenModal from '../../../components/full-screen-modal'
import { bookmarkMessage } from '../helpers'
import useStyles from '../index.styles'

const BookmarkDrawer = ({
  bookmarkingOpen,
  setBookmarkingOpen,
  selectedFolderId,
}: {
  bookmarkingOpen: boolean
  setBookmarkingOpen: (open: boolean) => void
  selectedFolderId: number | null
}) => {
  const classes = useStyles
  const navigate = useNavigate()

  return (
    <FullScreenModal
      open={bookmarkingOpen}
      onClose={() => setBookmarkingOpen(false)}
      title="Save for Later"
      showCloseIcon={true}
      confirmLabel="Got it!"
      onConfirm={() => {
        setBookmarkingOpen(false)
        navigate(selectedFolderId ? `/dashboard/${selectedFolderId}/devices` : '/dashboard', { state: { showBookmarkInfo: false } })
      }}
      isFullScreen={false}
    >
      <Typography variant="body1" sx={classes.bookmarkDescription}>
        We recommend bookmarking this app so you can easily access it later to view and manage your sensors.
      </Typography>
      <Alert variant="outlined" severity="info">
        <Typography variant="body2">{bookmarkMessage()}</Typography>
      </Alert>
    </FullScreenModal>
  )
}

export default BookmarkDrawer
